<template>
	<div>
		<div style="white-space: pre-wrap;">{{aboutThePlatform}}</div>
	</div>
</template>

<script>
	import {
		setContent
	} from "@/api/api.js"
	export default {
		data() {
			return {
				protocolSwitching: 1,
				aboutThePlatform: ''
			}
		},
		mounted() {
			// 获取查询参数
			// 如果是路径参数，假设路由配置为 /some-path/:id
			this.protocolSwitching = this.$route.query.type
			this.setUp()
		},
		methods: {
			setUp() {
				setContent().then(res => {
					if (this.protocolSwitching == 1) {
						this.aboutThePlatform = res.data[5].value
					} else {
						this.aboutThePlatform = res.data[6].value
					}
				})

			},
		}
	}
</script>

<style>
</style>